import React, { Component } from 'react';


class Detaylist extends Component {

  render(){
    let { Tarih, NumuneAdi, NumuneTipi, SonucDurum, RaporNo, AlimYeri, AltNo,NumuneAciklama } = this.props;
    return(
      <li>
        <div>
        {Tarih.substring(0,10)}
        </div>
        <div>{RaporNo} - {AltNo}</div>
        <div>{NumuneAdi}</div>
        <div>{AlimYeri?AlimYeri:'Yok'}</div>
        <div>{NumuneTipi}</div>
        <div><span className={`${SonucDurum}`}>{SonucDurum}</span></div>
        <div>{NumuneAciklama}</div>
      </li>
    )
  }
}


export default Detaylist;
